import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { bagActions } from "../store/bagSlice";
import { style } from "framer-motion/client";
import styles from "../Components/ProductList.module.css";
import thumbnailStyles from '../Components/Thumbnail.module.css';
import Api from "../Components/Api";
import Thumbnail from "../Components/Thumbnail";
const Stationery = ({shoptItemDetails}) => {
    const [details, setDetails] = useState({});
    const [productImageDetails, setProductImageDetails] = useState([]);
    const tableName = 'Stationery';

    useEffect(()=>{
        Api.get(`/product-by-table/${tableName}/${shoptItemDetails.id}`).then((response)=>{
            console.log(response.data[0])
            setDetails(response.data[0]);
        })
        Api.get(`/by-product-image-details/${shoptItemDetails.id}`).then((response)=>{
          console.log(response.data);
          setProductImageDetails(response.data);
        })
    },[])   

    const thumbnails = [
       { imgSrc: `${global.config.live_url}${shoptItemDetails.product_image}`, title: '' },
       
   ];
   console.log(productImageDetails);
   productImageDetails.forEach((prod)=>{    
    thumbnails.push({ imgSrc: `${global.config.live_url}${prod.image}`, title: '' })
   })
    const dispatch = useDispatch();  
  const bagIds = useSelector(store => store.bag.cartList); 
  const elementFound = bagIds.indexOf(shoptItemDetails.id) >= 0;
  
    const handleAddToBag = () => {
        dispatch(bagActions.addToBag(shoptItemDetails.id))
    }
  const handleRemoveFromBag = () => {    
    dispatch(bagActions.removeFromBag(shoptItemDetails.id));     
  }
  const [currentThumbnail, setCurrentThumbnail] = useState(thumbnails[0]);
  const handleClick = (index) => {
    setCurrentThumbnail(thumbnails[index]);
  };
    return <>
        <div className="row">
            <div class="col-sm-8">

                <div className={`row ${thumbnailStyles.flexContainer}`}>

                    {thumbnails.map((thumb, index) => (
                        <div><img key={index} src={thumb.imgSrc} width="50px" height="50px" onClick={() => handleClick(index)} title={thumb.title} alt="" />
                        </div>
                    ))}
                </div>
                <div className={`row ${thumbnailStyles.imageShowBox}`}>
                    <Thumbnail imgSrc={currentThumbnail.imgSrc} title={currentThumbnail.title} />
                </div>
            </div>
            <div class="col-sm-4">

                <h4>{shoptItemDetails.product_name}</h4>                
                <p>Brand - {shoptItemDetails.brand}</p>
                <p>{details.size!==null ? `Size - ${details.size}` : ''}</p>
                <p>Net Quantity - {details.net_quantity}</p>
                <p>{details.colour!==null ? `Colour - ${details.colour}` : ''} </p> 

                &#x20B9;{" "}
                {shoptItemDetails.product_offer > 0
                    ? Math.round(
                        shoptItemDetails.product_price -
                        (shoptItemDetails.product_price * shoptItemDetails.product_offer) / 100
                    )
                    : ""}{" "}
                {shoptItemDetails.product_offer > 0 ? (
                    <span className={styles.productPriceLineThrough}>
                        &#x20B9;{shoptItemDetails.product_price}
                    </span>
                ) : (
                    shoptItemDetails.product_price
                )}{" "}
                <br /> <br />
                {shoptItemDetails.product_in_stock > 0 ? (elementFound ? <button
                    onClick={handleRemoveFromBag}
                    className={`btn btn-outline-danger ${styles.addToCartButton}`}
                >

                    Remove
                </button> : <button
                    value={shoptItemDetails.id}
                    type="button"
                    className={`btn btn-outline-success ${styles.addToCartButton}`}
                    onClick={handleAddToBag}
                >
                    Add to Cart
                </button>) : <span className={`${styles.outOfStock}`}>Out of Stock</span>}

            </div>
        </div>
    </>

}
export default Stationery;